<template>
  <div class="home">
    <div class="home_top_bg">
      <img
        src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933872032/home_top_bg.png"
      />
      <div class="top_main">
        <div class="top_btn" @click="handleRouter">
          <span>了解更多</span>
          <span
            ><img
              src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933955203/right.png"
              alt=""
          /></span>
        </div>
      </div>
    </div>
    <div class="home_main bg1 mt40 profile_box">
      <div class="profile_img">
        <img
          src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933990106/home_main_img1.png"
        />
      </div>
      <div class="main_profile">
        <div class="profile_title"><span>公司</span><span>简介</span></div>
        <div class="profile_translate">Company Introduction</div>
        <div class="profile_text">
          中致远工程管理咨询有限公司成立于2019年6月，位于四川省成都市金牛区高新技术产业园区，是西部地区的一家综合性工程咨询管理公司，是中国建设工程造价管理协会成员单位，四川省监理协会、中国招标投标协会等多家协会成员单位。
        </div>
        <div class="profile_text">
          公司具有建设部房屋建筑工程监理甲级资质、市政工程监理甲级资质，电力工程甲级资质，机电安装工程监理乙级资质，通信监理乙级资质等；水利工程施工监理乙级；地质灾害治理工程监理乙级等。
        </div>
        <div class="profile_text">
          目前核心业务为：全过程工程咨询服务、全过程造价咨询、招标与采购专业咨询、工程监理与运维专业咨询以及全过程BIM项目管理等，是集多项业务于一体的技术密集型发展中企业。
        </div>
      </div>
    </div>
    <div class="home_main mt64 team_box">
      <div class="team_left bg2">
        <div class="team_user" v-for="(item, index) in teamList" :key="index">
          <div class="user_title">{{ item.title }}</div>
          <div class="user_number">{{ item.number }} <span>人</span></div>
        </div>
      </div>
      <div class="team_right">
        <div class="team_item">
          <div class="team_text">
            公司管理团队具有良好的职业道德素养，专业技术精湛，管理经验丰富，已成功地为客户提供各类工程项目的专业技术服务，深受同行和客户的信任与尊重。公司人才荟萃、专业齐全，拥有一支长期从事工程造价、工程监理、招标代理、技术咨询的高素质专业人才队伍。
          </div>
          <div class="team_text">
            建设部批准的全国监理工程师33人，一级造价工程师13人，注册安全工程师1人，水利监理工程师9人，交通监理工程师10人，一级建造师、其他专业从业人员20余人，其中高级工程师13人，中级工程师28人，为工程咨询业务开展奠定了良好、坚实的人力资源基础。
          </div>
        </div>
        <div class="team_item">
          <div class="team_text">
            公司成立至今，坚持精益求精、敬业诚信的经营服务理念，致力于为政府机构、行业用户和广大企事业单位提供全方位、全过程项目咨询服务。客户包括：四川省高级人民法院、成都市中级人民法院、攀枝花、德阳、内江、南充等多家地市级中级人民法院、广元市审计局、阿坝州审计局、巴中市住建局等多个地市级、县级人民政府、住建局、审计局、财政局，成都信息工程大学、成都大学等多所高等院校，国网四川省电力公司成都供电公司城西供电中心、成都市武侯社区商业投资发展有限责任公司、广东省电信规划设计院有限公司等多家企、事业单位，完成业主委托的各类咨询业务上千余项，投资额逾400多亿。
          </div>
          <div class="team_text">
            其中造价咨询项目：“若尔盖山水工程”全生命周期监测与适应性管理子项目、“6·10”马尔康地震灾后恢复重建2023年度跟踪审计第二阶段、三星堆浏阳路支线项目（一期工程）等；工程监理项目：九寨沟县柏悦丽豪酒店新建项目、炉霍县克木村生活垃圾高温热解建设项目监理服务等项目完成优良，为客户在投资、质量、进度、安全等方面做出了有效控制，受到客户和政府主管部门的好评。
          </div>
        </div>
      </div>
    </div>
    <div class="home_main mt64 four_box">
      <div class="four_item">
        <div class="item_title">
          <div class="line"></div>
          <div class="title">经营原则</div>
        </div>
        <div class="item_text">
          公司正在建设以现代企业制度体系为基础的模式实施企业经营管理，内部组织机构健全、设置合理，以“简单、可行、可控、可操作”为总体经营原则
        </div>
        <div class="item_img">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934178018/four_icon1.png"
            alt=""
          />
        </div>
      </div>
      <div class="four_item">
        <div class="item_title">
          <div class="line"></div>
          <div class="title">管理制度体系</div>
        </div>
        <div class="item_text">
          公司建立和完善了一套行之有效的、规范化、标准化、精细化、程序化的管理制度体系。
        </div>
        <div class="item_img">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934222605/four_icon2.png"
            alt=""
          />
        </div>
      </div>
      <div class="four_item">
        <div class="item_title">
          <div class="line"></div>
          <div class="title">经营目标</div>
        </div>
        <div class="item_text">
          公司以“专业化服务领先、职业化管理领先”为经营目标。
        </div>
        <div class="item_img">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934246082/four_icon3.png"
            alt=""
          />
        </div>
      </div>

      <div class="four_item">
        <div class="item_title">
          <div class="line"></div>
          <div class="title">质量目标</div>
        </div>
        <div class="item_text">
          以“严格管理、优质服务、确保工程质量百分之百合格、服务承诺百分之百落实”为公司质量目标，高标准、高水平地为业主提供及时、全面的优质服务。
        </div>
        <div class="item_img">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934266051/four_icon4.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="qualifications">
      <div class="qualifications_title"><span>公司</span><span>资质</span></div>
      <div class="qualifications_translate">Qualification Certificate</div>
      <div class="carousel_box">
        <div class="carousel_content">
          <NCarousel show-arrow autoplay draggable>
            <div
              class="carousel_item"
              v-for="(item, index) in carouselList"
              :key="index"
              :style="'width:' + item.width + 'px'"
            >
              <div class="item_img">
                <div class="img" v-for="(label, idx) in item.icon" :key="idx">
                  <img :src="label" alt="" />
                </div>
              </div>
              <div class="item_title">{{ item.title }}</div>
            </div>
            <template #dots="{ total, currentIndex, to }">
              <div class="tab_box">
                <div
                  class="tab_item"
                  v-for="index of total"
                  :key="index"
                  :class="{ ['active']: currentIndex === index - 1 }"
                  @click="to(index - 1)"
                ></div>
              </div>
            </template>
          </NCarousel>
        </div>
      </div>
    </div>
    <div class="home_main mt64 zs_wrap">
      <div class="home_title"><span>信用</span><span>证书</span></div>
      <div class="home_translate">Credit Certificate</div>
      <div class="zs_box">
        <div
          class="zs_item"
          :class="item.isbtm ? 'zs_item_btm' : ''"
          v-for="(item, index) in certificateList"
          :key="index"
        >
          <img :src="item.url" alt="" />
        </div>
      </div>
    </div>
    <div class="contact mt64">
      <div class="contact_main">
        <div class="contact_wrap">
          <div class="contact_title"><span>联系</span><span>我们</span></div>
          <div class="contact_translate">Contact Us</div>
          <div class="wrap_box">
            <div class="wrap_left">
              <div class="contact_item">
                <div>公司地址</div>
                <div>成都市金牛区金科南路169号1栋10层1016号</div>
              </div>
              <div class="contact_item">
                <div>联系电话</div>
                <div>028-61666051</div>
              </div>
            </div>
            <div class="wrap_right">
              <div class="right_title">留下您的联系方式</div>
              <div class="feedback">
                <NInput
                  v-model:value="name"
                  type="text"
                  style="width: 200px"
                  placeholder="输入您的姓名"
                />
                <NInput
                  v-model:value="phone"
                  type="text"
                  style="width: 200px; margin-left: 16px"
                  placeholder="输入您的联系电话"
                />
              </div>
              <div class="feedback">
                <NInput
                  v-model:value="content"
                  placeholder="简要说明您想资讯的内容"
                  type="textarea"
                  style="width: 416px"
                  :autosize="{
                    minRows: 3,
                    maxRows: 5,
                  }"
                />
              </div>
              <div class="feedback_btn" @click="handleSubmit">发送</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { useMessage } from "naive-ui";
import { NCarousel, NInput } from "naive-ui";

import { useRouter } from "vue-router";

import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  getCurrentInstance,
  onMounted,
} from "vue";

export default defineComponent({
  components: {
    NCarousel,
    NInput,
  },
  setup() {
    const { proxy } = getCurrentInstance() as any;
    const router = useRouter();
    const message = useMessage();
    const state = reactive({
      name: "",
      phone: "",
      content: "",
    });
    const teamList = [
      { title: "监理工程师", number: 33 },
      { title: "一级造价工程师", number: 13 },
      { title: "注册安全工程师", number: 1 },
      { title: "水利监理工程师", number: 9 },
      { title: "交通监理工程师", number: 10 },
      { title: "一级建造师", number: 20 },
    ];
    const carouselList = [
      {
        title: "房屋建筑工程监理甲级、市政工程监理甲级、电力工程甲级",
        width: 1344,
        icon: [
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934385563/ca_1_img1.png",
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934385587/ca_1_img2.png",
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934385743/ca_1_img3.png",
        ],
      },
      {
        title: "通信工程、化工石油工程、机电安装工程监理乙级",
        width: 810,
        icon: [
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934442510/ca_2_img1.png",
        ],
      },
      {
        title: "工程造价咨询乙级",
        width: 522,
        icon: [
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934464627/ca_3_img1.png",
        ],
      },
      {
        title: "水利工程施工监理乙级",
        width: 942,
        icon: [
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934484395/ca_4_img1.png",
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934484435/ca_4_img2.png",
        ],
      },
      {
        title: "地质灾害治理工程监理乙级",
        width: 522,
        icon: [
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934532068/ca_5_img1.png",
        ],
      },
      {
        title:
          "环境管理体系认证证书、职业健康安全管理体系认证证书、质量管理体系认证证书",
        width: 1344,
        icon: [
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934552782/ca_6_img1.png",
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934552807/ca_6_img2.png",
          "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934552917/ca_6_img3.png",
        ],
      },
    ];
    const certificateList = [
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934623910/zs_1.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624041/zs_2.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624156/zs_3.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624280/zs_4.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624441/zs_5.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624469/zs_6.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624500/zs_7.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624526/zs_8.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624554/zs_9.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624597/zs_10.png",
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624646/zs_11.png",
        isbtm: true,
      },
      {
        url: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934624677/zs_12.png",
        isbtm: true,
      },
    ];
    onMounted(() => {});
    const handleSubmit = async () => {
      try {
        let params = {
          name: state.name,
          phone: state.phone,
          content: state.content,
        };
        const url = `/api/t_base_content_remarks/save`; // 通过代理路径访问
        const response = await fetch(url, {
          method: "POST",
          body: JSON.stringify(params),
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP Error! 状态码: ${response.status}`);
        }

        const data = await response.json();
        if (data.code == 200) {
          message.success("发送成功");
          state.name = "";
          state.phone = "";
          state.content = "";
        } else {
          message.error(data.message);
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    };

    const handleRouter = () => {
      router.push("/core");
    };
    return {
      handleSubmit,
      handleRouter,
      carouselList,
      certificateList,
      teamList,
      ...toRefs(state),
    };
  },
});
</script>
<style scoped lang="scss">
.home {
  .home_top_bg {
    width: 100%;
    height: 624px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 624px;
      object-fit: cover;
    }
    .top_main {
      position: absolute;
      width: 1600px;
      left: 50%;
      transform: translateX(-50%);
      top: 393px;
      .top_btn {
        width: 200px;
        height: 48px;
        border-radius: 24px;
        border: 1px solid #000000;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 32px;
        box-sizing: border-box;
        cursor: pointer;
        span {
          font-size: 16px;
          color: #000000;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
  .home_main {
    width: 1600px;
    margin: 0 auto;
    position: relative;
    .home_title {
      text-align: center;
      span:nth-of-type(1) {
        font-weight: 600;
        font-size: 40px;
        color: #000000;
      }
      span:nth-of-type(2) {
        font-weight: 600;
        font-size: 40px;
        color: #317ed2;
      }
    }
    .home_translate {
      text-align: center;
      font-size: 24px;
      color: #a9a9a9;
      padding: 2px 0px 0px;
    }
  }
  .mt40 {
    margin-top: 40px;
  }
  .mt64 {
    margin-top: 64px;
  }
  .bg1 {
    background: url("https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934037661/home_main_bg1.png")
      no-repeat;
    background-size: 100% 100%;
  }
  .profile_box {
    padding: 60px 80px;
    box-sizing: border-box;
    height: 518px;
    .main_profile {
      .profile_title {
        span:nth-of-type(1) {
          font-weight: 600;
          font-size: 40px;
          color: #000000;
        }
        span:nth-of-type(2) {
          font-weight: 600;
          font-size: 40px;
          color: #317ed2;
        }
      }
      .profile_translate {
        font-size: 24px;
        color: #a9a9a9;
        padding: 2px 0px 20px;
      }
      .profile_text {
        width: 756px;
        font-size: 16px;
        color: #000000;
        padding: 12px 0px;
      }
    }
    .profile_img {
      position: absolute;
      right: 0;
      top: 49px;
      img {
        display: block;
      }
    }
  }
  .team_box {
    height: 618px;
    background: #ffffff;
    display: flex;
    .bg2 {
      background: url("https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934097630/home_main_bg2.png")
        no-repeat;
      background-size: 100% 100%;
      width: 753px;
      height: 618px;
      margin-left: -160px;
      padding-left: 222px;
      padding-top: 52px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      .team_user {
        width: 50%;
        .user_title {
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
        }
        .user_number {
          font-weight: bold;
          font-size: 64px;
          color: #52ceff;
          span {
            font-size: 20px;
            color: #ffffff;
          }
        }
      }
    }
    .team_right {
      width: calc(100% - 583px);
      padding: 36px 60px 0px;
      .team_item {
        padding-top: 24px;
        .team_text {
          font-size: 16px;
          color: #000000;
          padding-bottom: 24px;
        }
      }
    }
  }
  .four_box {
    display: flex;
    justify-content: space-between;
    .four_item {
      width: calc(100% / 4 - 16px);
      background: #ffffff;
      padding: 32px 24px;
      position: relative;
      height: 260px;
      box-sizing: border-box;
      .item_title {
        display: flex;
        align-items: center;
        .line {
          width: 4px;
          height: 26px;
          background: #377dca;
        }
        .title {
          padding-left: 20px;
          font-weight: 600;
          font-size: 24px;
          color: #000000;
        }
      }
      .item_text {
        padding-top: 24px;
        font-size: 16px;
        color: #000000;
        position: relative;
        z-index: 10;
      }
      .item_img {
        position: absolute;
        right: 16px;
        bottom: 16px;
      }
    }
  }
  .qualifications {
    padding-top: 100px;
    .qualifications_title {
      text-align: center;
      span:nth-of-type(1) {
        font-weight: 600;
        font-size: 40px;
        color: #000000;
      }
      span:nth-of-type(2) {
        font-weight: 600;
        font-size: 40px;
        color: #317ed2;
      }
    }
    .qualifications_translate {
      text-align: center;
      font-size: 24px;
      color: #a9a9a9;
      padding: 2px 0px 32px;
    }
    .carousel_box {
      width: 100vw;
      background: url("https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934284662/ca_bg.png")
        no-repeat;
      background-size: 100% 100%;
      padding: 60px 0px 80px;
      .carousel_content {
        .carousel_item {
          margin: 0 auto;
          height: 480px;
          box-sizing: border-box;
          backdrop-filter: blur(5px);
          background-color: rgba(255, 255, 255, 0.8);
          border-radius: 16px;
          border: 2px solid #ffffff;
          padding: 60px 50px 40px;
          .item_img {
            display: flex;
            justify-content: center;
            .img {
              margin: 0 16px;
              display: block;
              height: 280px;
            }
          }
          .item_title {
            margin-top: 40px;
            box-sizing: border-box;
            height: 60px;
            background: #ffffff;
            box-shadow: 0px 4px 12px 0px rgba(8, 92, 184, 0.2);
            border-radius: 30px;
            font-weight: 600;
            font-size: 24px;
            color: #377dca;
            line-height: 60px;
            text-align: center;
          }
        }
        .w1344 {
          width: 1344px;
        }
      }
      .tab_box {
        display: flex;
        justify-content: center;
        padding-top: 44px;
        .tab_item {
          width: 12px;
          height: 12px;
          background: #ffffff;
          border-radius: 6px;
          cursor: pointer;
          margin: 0 8px;
          transition: all 0.5s;
        }
        .active {
          width: 120px;
          height: 12px;
          background: #ffffff;
          border-radius: 6px;
        }
      }
    }
  }
  .zs_wrap {
    box-sizing: border-box;
    padding: 48px 93px 32px;
    background: #ffffff;
    .zs_box {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .zs_item {
        width: 20%;
        text-align: center;
        margin-top: 48px;
      }
      .zs_item_btm {
        width: 341px;
        margin: 48px 33px 0px;
      }
    }
  }
  .contact {
    background: url("https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934806567/contact_bg.png")
      no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 60px 0px 34px;
    .contact_main {
      width: 1600px;
      margin: 0 auto;
      position: relative;
      display: flex;
      justify-content: flex-end;
      .contact_wrap {
        box-sizing: border-box;
        width: 1139px;
        height: 548px;
        background: rgba(255, 255, 255, 0.8);
        padding: 68px 109px 88px 86px;
        .contact_title {
          span:nth-of-type(1) {
            font-weight: 600;
            font-size: 40px;
            color: #000000;
          }
          span:nth-of-type(2) {
            font-weight: 600;
            font-size: 40px;
            color: #317ed2;
          }
        }
        .contact_translate {
          font-size: 24px;
          color: #a9a9a9;
          padding: 2px 0px 0px;
        }
        .wrap_box {
          display: flex;
          justify-content: space-between;
          .wrap_left {
            .contact_item {
              padding-top: 48px;
              div:nth-of-type(1) {
                font-weight: 600;
                font-size: 24px;
                color: #333333;
              }
              div:nth-of-type(2) {
                padding-top: 16px;
                font-size: 20px;
                color: #666666;
              }
            }
          }
          .wrap_right {
            .right_title {
              padding-top: 51px;
              font-weight: 600;
              font-size: 16px;
              color: #333333;
            }
            .feedback {
              display: flex;
              padding: 16px 0px;
            }
            .feedback_btn {
              width: 100%;
              height: 36px;
              background: #377dca;
              border-radius: 4px;
              text-align: center;
              line-height: 36px;
              cursor: pointer;
              font-size: 16px;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
}
</style>